var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"notification",class:{
    'notification--error': _vm.type === 'error',
    'notification--success': _vm.type === 'success'
  },attrs:{"role":"alert"}},[_vm._v("\n\n  "+_vm._s(_vm.text)+"\n\n  "),_c('button',{staticClass:"notification__button",attrs:{"aria-label":"Benachrichtigung schließen"},on:{"click":function($event){return _vm.$emit('remove')}}})])}
var staticRenderFns = []

export { render, staticRenderFns }